import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    errors: {
      differentEmails: 'Email addresses don’t match',
      emailAlreadyExists: 'This email address is already taken',
      newEmailEqualsCurrent:
        'This e-mail address is identical to the one currently used',
      wrongFormat: 'Format d’adresse e-mail invalide',
    },
    newEmail: 'New email address',
    newEmailConfirmation: 'Confirmation of the new email address',
    save: 'Save',
    subtitle: 'We use your email address to send you important communications.',
    success: 'Email address successfully changed',
    title: 'Change your email address',
  },
  fr: {
    errors: {
      differentEmails: 'Les adresses e-mail ne sont pas identiques',
      emailAlreadyExists: 'Cette adresse e-mail est déjà prise',
      newEmailEqualsCurrent:
        'Cette adresse e-mail est identique à votre adresse e-mail actuelle',
      wrongFormat: 'Format d’adresse e-mail invalide',
    },
    newEmail: 'Nouvelle adresse e-mail',
    newEmailConfirmation: 'Confirmation de la nouvelle adresse e-mail',
    save: 'Enregistrer',
    subtitle:
      'Nous utilisons votre adresse e-mail pour vous envoyer des communications importantes.',
    success: 'Adresse e-mail modifiée avec succès',
    title: 'Modifier votre adresse e-mail',
  },
} as const);

export default locales;
